import { render } from "./agentLogin.vue?vue&type=template&id=5d244ed6&scoped=true"
import script from "./agentLogin.vue?vue&type=script&lang=js"
export * from "./agentLogin.vue?vue&type=script&lang=js"

import "./agentLogin.vue?vue&type=style&index=0&id=5d244ed6&lang=scss&scoped=true"

import exportComponent from "E:\\wwwroot\\qifu-web-v1.0.0\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d244ed6"]])

export default __exports__